<template>
  <div>
    <v-card>
      <v-card-title>Schichtpläne</v-card-title>

      <v-list>
        <span v-for="(route, i) in router" :key="i">
          <v-list-item
            v-if="route.component == 'EpLandshutPlan'"
            @click="open(route)"
          >
            <v-list-item-icon>
              <v-icon>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ route.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider v-if="route.component == 'EpLandshutPlan'"></v-divider>
        </span>
      </v-list>

      <v-card-title>Links zum Bereitstellen</v-card-title>

      <v-list>
        <span v-for="(route, i) in router" :key="i">
          <v-list-item
            v-if="route.component == 'EpLandshutUpload'"
            @click="open(route)"
          >
            <v-list-item-icon>
              <v-icon>mdi-upload</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ route.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-divider v-if="route.component == 'EpLandshutUpload'"></v-divider>
        </span>
      </v-list>
    </v-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: [
        {
          path: "/ep",
          component: "EpLandshutPlan",
          name: "EP Landshut Plan",
        },
        //IT-REUDE
        {
          path: "/10023251",
          component: "EpLandshutPlan",
          name: "Regional Deutschland Plan",
        },

        {
          path: "/10169300",
          component: "EpLandshutPlan",
          name: "EPLD11 Landshut Plan",
        },
        /*
    ## Sensoren / Automotive / Opto Sockel ##
    10000754 - EP-LD2
    10019994 - EP-LD21
    */
        {
          path: "/10019994",
          component: "EpLandshutPlan",
          name: "EPLD21 Landshut Plan",
        },
        /*
    ## Opto Kappen ##
    10000764 - EP-LD31
    10000755 - EP-LD3
    */
        {
          path: "/10000764",
          component: "EpLandshutPlan",
          name: "EPLD31 Landshut Plan",
        },
        /*
    ## Löt und Filterkappen ##
    10020014 - EP-LD41
    10000756 - EP-4
    */
        {
          path: "/10020014",
          component: "EpLandshutPlan",
          name: "EPLD41 Landshut Plan",
        },

        /*
    ## Glasabschnitte ##
    10000729 - EP-LG2
    10000724 - EP-LG
    */
        {
          path: "/10000729",
          component: "EpLandshutPlan",
          name: "EPLG2 Landshut Plan",
        },
        /*
     ## Gestellgalvanik ##
        10007681 - EP-LO11
        10109175 - EP-LO1    
    */
        {
          path: "/10007681",
          component: "EpLandshutPlan",
          name: "EPLO11 Landshut Plan",
        },
        /*
    ## Trommelgalvanik ##
        10109176 - EP-LO12
        10109175 - EP-LO1
    */
        {
          path: "/10109176",
          component: "EpLandshutPlan",
          name: "EPLO12 Landshut Plan",
        },
        /*
    ## Fertigung Hybrid ##
        10000760 - EP-LD51
        10111136 - EP-LD5
    */
        {
          path: "/10000760",
          component: "EpLandshutPlan",
          name: "EPL51 Landshut Plan",
        },
        /*
    ## Fertigung LED ##
        10179231 - EP-LD52
        10111136 - EP-LD5
        00009654 - Employee ID for Ludwig Mittermeier - He is leading LD51 and LD52
    */
        {
          path: "/10179231",
          component: "EpLandshutPlan",
          name: "EPLD52 Landshut Plan",
        },
        /*
    ## Fertigung Presslinge ##
        10000728 - EP-LG3
    */
        {
          path: "/10000728",
          component: "EpLandshutPlan",
          name: "EPLG3 Landshut Plan",
        },
        /*
    ## Fertigung Glaspulver ##
        10076762 - EP-LG4
    */
        {
          path: "/10076762",
          component: "EpLandshutPlan",
          name: "EPLG4 Landshut Plan",
        },
        //IT-RC
        {
          path: "/10200860",
          component: "EpLandshutPlan",
          name: "IT-RC Plan",
        },

        //#################################################################################################################
        /**
     * UPLOAD PAGES
     ##################################################################################################################
     */

        /*
        ## Großdurchführnugen
        10169300 - EP-LD11
        10023388 - EP-LD1
        */
        {
          path: "/10169300upload",
          component: "EpLandshutUpload",
          name: "EPLD11 Upload",
        },
        /*
    ## Sensoren / Automotive / Opto Sockel ##
    10000754 - EP-LD2
    10019994 - EP-LD21
    */
        {
          path: "/10019994upload",
          component: "EpLandshutUpload",
          name: "EPLD21 Upload",
        },
        /*
    ## Opto Kappen ##
    10000764 - EP-LD31
    10000755 - EP-LD3
    */
        {
          path: "/10000764upload",
          component: "EpLandshutUpload",
          name: "EPLD31 Upload",
        },
        /*
    ## Löt und Filterkappen ##
    10020014 - EP-LD41
    10000756 - EP-4
    */
        {
          path: "/10020014upload",
          component: "EpLandshutUpload",
          name: "EPLD41 Upload",
        },

        /*
    ## Glasabschnitte ##
    10000729 - EP-LG2
    10000724 - EP-LG
    */
        {
          path: "/10000729upload",
          component: "EpLandshutUpload",
          name: "EPLG2 Upload",
        },
        /*
     ## Gestellgalvanik ##
        10007681 - EP-LO11
        10109175 - EP-LO1    
    */
        {
          path: "/10007681upload",
          component: "EpLandshutUpload",
          name: "EPLO11 Upload",
        },
        /*
    ## Trommelgalvanik ##
        10109176 - EP-LO12
        10109175 - EP-LO1
    */
        {
          path: "/10109176upload",
          component: "EpLandshutUpload",
          name: "EPLO12 Upload",
        },
        /*
    ## Fertigung Hybrid ##
        10000760 - EP-LD51
        10111136 - EP-LD5
    */
        {
          path: "/10000760upload",
          component: "EpLandshutUpload",
          name: "EPLD51 Upload",
        },
        /*
 ## Fertigung LED ##
     10179231 - EP-LD52
     10111136 - EP-LD5
     00009654 - Employee ID for Ludwig Mittermeier - He is leading LD51 and LD52
 */
        {
          path: "/10179231upload",
          component: "EpLandshutUpload",
          name: "EPLD52 Upload",
        },
        /*
 ## Fertigung Presslinge ##
     10000728 - EP-LG3
 */
        {
          path: "/10000728upload",
          component: "EpLandshutUpload",
          name: "EPLG3 Upload",
        },
        /*
 ## Fertigung Glaspulver ##
     10076762 - EP-LG4
 */
        {
          path: "/10076762upload",
          component: "EpLandshutUpload",
          name: "EPLG4 Upload",
        },

        //Spielwiese
        {
          path: "/epupload",
          component: "EpLandshutUpload",
          name: "EP Landshut Upload",
        },
        //Spielwiese
        {
          path: "/10023251upload",
          component: "EpLandshutUpload",
          name: "Regional IT Deutschland Upload",
        },
        //IT-RC
        {
          path: "/10200860upload",
          component: "EpLandshutUpload",
          name: "Upload IT-RC Plan",
        },
      ],
    };
  },
  methods: {
    open: function (route) {
      this.$router.push({ path: route.path });
    },
  },
};
</script>


